import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import JenisPrestasiService from "../../services/JenisPrestasiService";
import {message} from "antd";

export const initialState = {
    loading: false,
    dataJenisPrestasi: [],
    dataJenisPrestasiByID:[],
    showMessage:false,
    message:''
}


export const getDataJenisPrestasi = createAsyncThunk('ref/jenis_prestasi',async (data, { rejectWithValue }) => {
    try {
        const response = await JenisPrestasiService.getDataAll(data)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataJenisPrestasiByID = createAsyncThunk('ref/jenisprestasibyid',async (data, { rejectWithValue }) => {
    const {token,id}=data;
    try {
        const response = await JenisPrestasiService.getDataByID(token,id)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const jenisPrestasiSlice = createSlice({
    name: 'jenis_prestasi',
    initialState,
    reducers: {
        showDataSuccess: (state, action) => {
            state.loading = false
            state.dataJenisPrestasi = action.payload
        },
        showLoading: (state) => {
            state.loading = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataJenisPrestasi.fulfilled, (state, action) => {
                state.loading = false
                state.dataJenisPrestasi = action.payload
            })
            .addCase(getDataJenisPrestasi.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataJenisPrestasi.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.dataJenisPrestasi = action.payload
            })

    },
})

export const {
    showDataSuccess,
    showLoading
} = jenisPrestasiSlice.actions

export default jenisPrestasiSlice.reducer
